import { Button } from 'components';

const SUPER_EXPRESS_CARD_HEIGHT = 152;
const CARD_GAP = 15;

interface Props {
  onClose: () => void;
  superExpressCount: number;
}

export function ConsignmentListOverlay({ onClose, superExpressCount }: Props) {
  const clampedCount = Math.min(superExpressCount, 3);
  const topPosition =
    SUPER_EXPRESS_CARD_HEIGHT * clampedCount + CARD_GAP * clampedCount;

  return (
    <div
      className="absolute left-0 flex size-full flex-col items-center
        justify-start gap-2 py-6"
      style={{
        top: `${topPosition}px`,
        background:
          'linear-gradient(to bottom, rgba(30,30,30,0.9) 0%, rgba(30,30,30,0.5) 63.46%, rgba(30,30,30,0) 100%)',
      }}
    >
      <p className="text-center text-sm font-bold text-white">
        Dê prioridade a pedidos Super Expresso
      </p>
      <Button
        variant="link"
        className="text-center text-sm font-bold text-white"
        aria-label="Fechar overlay"
        onClick={onClose}
      >
        Fechar X
      </Button>
    </div>
  );
}
